import React, { useContext, useState, useEffect, useReducer } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import { Box } from "@material-ui/core";
import { Delete, Edit as EditIcon, Visibility as ViewIcon } from "@material-ui/icons";
import { ICON_COLOUR } from "../../../../../lib/constants/style_constants";
import Grid from "@material-ui/core/Grid";
import { useTheme } from "@material-ui/core";
import AddIcon from '@material-ui/icons/AddBox';
import tableIcons, {
  options,
} from "../../../../../components/universal/table_attributes";
import tableReducer, {
  INITIAL_TABLE_STATE,
} from "../../../../../reducers/table_reducer";
import MaterialTable from "material-table";
import TableAction from "../../../../../actions/table_actions";
import _ from "lodash";
import InvoiceRecord from "./InvoiceRecord";
import WorkshopReportService from "lib/services/api/accounts/workshop";
import { ToastMessageContext } from "lib/contexts/message_context";
import { getColors } from "lib/utils/common_utils";


const useStyles = makeStyles((theme) => ({
  subTitle: {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "10px",
    marginTop: "20px",
  },
}));



function Invoices(props) {
  const classes = useStyles();
  const theme = useTheme();
  const message = useContext(ToastMessageContext);
  const { financeOrderList,
    orderType,
    getFinanceWorkshopOrderList,
    type,
    currentSelection,
    height,
    isInvoiceOpen = false } = props
  const [tableState, dispatch] = useReducer(tableReducer, INITIAL_TABLE_STATE);
  const { page, totalCount, pageSize } = tableState;
  // const [loading, setLoading] = useState(false);
  const [action, setAction] = useState(null);
  const [invoiceLoading, setInvoiceLoading] = useState(false)
  const [invoiceList, setInvoiceList] = useState([])
  const [currentSelectedInvoice, setCurrentSelectedInvoice] = useState({})
  const [remaining, setRemaining] = useState(0)
  const [invoiceDetails, setInvoiceDetails] = useState({})







  const handlePaymentDetails = (rowData) => {

    const formData = new FormData()

    let status = false
    let filter = []
    if (invoiceList.length > 0 && !rowData?.paid) {
      filter = invoiceList?.filter((item) => (item.paid === false || item.paid === null) && item.id !== rowData?.id)
      console.log(filter)
      if ((invoiceList.length === 1 && +remaining === 0) || filter.length === 0) {
        status = true
      }

    }

    setInvoiceLoading(true)
    formData.append("workshop_order_invoice_id", rowData?.id)
    formData.append("reportable_type", type)
    formData.append("reportable_id", financeOrderList.id)
    formData.append("invoice_paid", rowData?.paid === true ? false : true)
    formData.append("parent_paid", status)

    WorkshopReportService.updatePaymentDetails(formData).then((res) => {
      getWorkshopInvoices()
      message.showToastMessage({
        message: "Status updated successfully !",
        variant: "success",
      });

    }).catch(() => {
      message.showToastMessage({
        message: "Something went wrong. Try again!",
        variant: "error",
      });
    }).finally(() => {
      setInvoiceLoading(false)
    })



  }

  const handleDeleteInvoice = (rowData) => {
    const formData = new FormData()
    formData.append("workshop_order_invoice_id", rowData?.id)
    formData.append("reportable_type", type)
    formData.append("reportable_id", financeOrderList.id)
    setInvoiceLoading(true)
    WorkshopReportService.deleteInvoice(formData).then((res) => {
      getWorkshopInvoices()
      message.showToastMessage({
        message: "Deleted successfully !",
        variant: "success",
      });

    }).catch((res) => {
      message.showToastMessage({
        message: res?.error ? res?.error.join(", ") : "Something went wrong. Try again!",
        variant: "error",
      });
    }).finally(() => {
      setInvoiceLoading(false)
    })

  }


  const handleClose = () => {

    setAction(null)
    getWorkshopInvoices()
    getFinanceWorkshopOrderList()

  }


  // Ui-table column config
  const stockColumnConfig = [
    {
      title: "Ref #",
      field: "invoice_number",
      width: "20%",
      headerStyle: {
        paddingLeft: "19px",
        textAlign: "left", width: "20%",
      },
      cellStyle: {
        paddingLeft: "19px",
        textAlign: "left",
        width: "20%",
      },
    },
    {
      title: "Type",
      field: "type",

      headerStyle: {
        textAlign: "left",

      },
      cellStyle: {
        textAlign: "left",

      },
      render: (rowData) => rowData?.type === 0 ? "Invoice" : rowData?.type === 1 ? "Credit" : ""
    },
    {
      title: "Date",
      field: "invoice_date",
      width: "10%",
      headerStyle: {
        textAlign: "left",
        width: "10%"
      },
      cellStyle: {
        textAlign: "left",
        width: "10%"
      },
    },
    {
      title: "Value",
      field: "net_value",
      headerStyle: {
        textAlign: "right",
      },
      cellStyle: {
        textAlign: "right",
      },
    },
    {
      title: "Status",
      field: "paid",


      render: (rowData) => <a onClick={() => {
        handlePaymentDetails(rowData)
      }}
        style={{
          textDecoration: isInvoiceOpen ? "underline" : "",
          textDecorationColor: rowData?.paid === true ? getColors("green") : getColors("red"),
          color: rowData?.paid === true ? getColors("green") : getColors("red"),
          pointerEvents: !isInvoiceOpen ? "none" : ""
        }}>
        {rowData?.paid === true ? "Paid" : "Unpaid"}
      </a>
    },
    {
      title: "Action",
      headerStyle: {
        textAlign: "center",
      },
      cellStyle: {
        textAlign: "center",

      },
      render: (rowData) => (
        !!props.permission?.write && isInvoiceOpen &&
        <>
          <IconButton
            // disabled={!props.permission.write}
            onClick={() => {
              setAction("UpdateInvoice");
              setCurrentSelectedInvoice(rowData);
            }}
          >
            <EditIcon fontSize="small" style={{ color: ICON_COLOUR }} />
          </IconButton>
          <IconButton
            // disabled={!props.permission.write}
            onClick={() => {
              handleDeleteInvoice(rowData)
            }}
          >
            <Delete fontSize="small" style={{ color: ICON_COLOUR }} />
          </IconButton>
        </>
      ),
    },
  ];

  // tableOptions
  const stockTableOptions = {
    ...options,
    paging: false,
    search: false,
    toolbar: false,
  };

  // get invoice api 
  //Invoice Api

  const getWorkshopInvoices = () => {
    setInvoiceLoading(true)
    const params = {
      workshop_order_id: currentSelection.id,
      // page: page + 1,
      // limit: pageSize,
      reportable_id: currentSelection.id,
      reportable_type: type
    }
    WorkshopReportService.getWorkshopInvoice(params).then((response) => {
      setInvoiceList(response?.data?.listing)
      setRemaining(response?.data?.remaining)
      setInvoiceDetails(response?.data)

      TableAction.setTotalCount(dispatch, response.total_count);
    }).catch((e) => {

      message.showToastMessage({
        message: "Something went wrong. Try again!",
        variant: "error",
      });

    }).finally(() => {
      setInvoiceLoading(false)
    })
  }
  useEffect(() => {
    if (currentSelection.id) { getWorkshopInvoices() }
  }, [currentSelection.id, page, pageSize, totalCount])

  const handleCreate = () => {
    return <IconButton onClick={() => {
      setAction('create');
    }} style={{ marginTop: "17px" }}>
      <AddIcon color="secondary" />
    </IconButton>
  }


  return (
    <Grid>
      <Grid container xs={12}>
        <Grid item xs={11}>
          <Typography variant="h6" className={classes.subTitle}>
            Invoices / Credits
          </Typography></Grid>
        <Grid item xs={1}>
          {(props.permission?.write && isInvoiceOpen) ? handleCreate() : ""}

        </Grid>



      </Grid>

      <MaterialTable
        style={{ height: height ?? '396px', overflow: "scroll" }}
        icons={tableIcons}
        title={""}
        columns={stockColumnConfig}
        data={invoiceList || []}
        isLoading={invoiceLoading}
        options={stockTableOptions}
        onChangePage={(page) => {
          TableAction.setPage(dispatch, page);
        }}
        onChangeRowsPerPage={(pageSize) => {
          TableAction.setPageSize(dispatch, pageSize);
        }}

        totalCount={totalCount}
        page={page}


      />
      <Grid
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "10px"
        }}>
        <Typography
          style={{ fontSize: "14px" }}>
          Total Invoiced / Credited (Net)
        </Typography>
        <Typography
          style={{ fontSize: "14px" }}
          color="primary">
          {invoiceDetails?.total_invoiced ?? "-"}
        </Typography>
      </Grid>
      {orderType !== "Storage" &&
        <Grid style={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: "14px",
          marginTop: "8px"
        }}>
          <Typography
            style={{ fontSize: "14px" }}>
            Remaining (Net)
          </Typography>
          <Typography
            style={{ fontSize: "14px" }}
            color="primary">
            {remaining ?? "-"}
          </Typography>
        </Grid>}
      {action && (
        <InvoiceRecord
          handleClose={handleClose}
          financeOrderList={financeOrderList}
          orderType={orderType}
          action={action}
          type={type}
          remaining={remaining}
          invoiceDetails={invoiceDetails}
          {...(action === "UpdateInvoice" && { currentSelectedInvoice })}
        />
      )}
    </Grid>
  );
}

export default Invoices;
